import auth from "../../services/auth";
import router from "@/router.js";

export default {
  me({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      auth
        .Me()
        .then((res) => {
          // dispatch("api/handleServiceException", { e: res }, { root: true });
          if (res.status == 200) {
            const user = res.data.data;
            localStorage.setItem("user", JSON.stringify(user));
            commit("userMe", user);
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch((err) => {
          dispatch("api/handleServiceException", { e: err }, { root: true });
          reject(err);
        });
    });
  },
  getMeta({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      auth
        .getMeta()
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          dispatch("api/handleServiceException", { e: err }, { root: true }); 
          reject(err);
        });
    });
  },
  login({ commit, dispatch }, userData) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      auth
        .login(userData)
        .then((res) => {
          dispatch("api/handleServiceException", { e: res }, { root: true });
          if (res.status == 200) {
            const token = res.data.data.auth_key;
            const user = res.data.data;
            localStorage.setItem("token", token);
            localStorage.setItem("user", JSON.stringify(user));
            commit("auth_success", token);
            commit("userMe", user);
            commit("authStatus", token);
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch((err) => { 
          dispatch("api/handleServiceException", { e: err } , { root: true });

          commit("auth_error", "");
          commit("logout", "");
          reject(err);
        });
    });
  },
 
  sessionExpired({ dispatch, commit }, { router }) {
    dispatch("alert/clear", {}, { root: true });
    // commit("logout");
    dispatch("logout");
    dispatch(
      "alert/error",
      {
        showType: "toast",
        text: "Session expired. Please login with your account.",
      },
      { root: true }
    );

    this.$router.push("/login");
  },

  updateMe({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      auth
        .updateMe(payload)
        .then((res) => {
          dispatch("api/handleServiceException", { e: res }, { root: true });
          resolve(res);
        })
        .catch((err) => {
          dispatch("api/handleServiceException", { e: err }, { root: true });
          reject(err);
        });
    });
  },
  updateMeta({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      auth
        .updateMeta(payload)
        .then((res) => {
          dispatch("api/handleServiceException", { e: res }, { root: true });
          resolve(res);
        })
        .catch((err) => {
          dispatch("api/handleServiceException", { e: err }, { root: true });
          reject(err);
        });
    });
  },
  uploadAvatar({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      auth
        .uploadAvatar(payload)
        .then((res) => {
          dispatch("api/handleServiceException", { e: res }, { root: true });
          resolve(res);
        })
        .catch((err) => {
          dispatch("api/handleServiceException", { e: err }, { root: true });
          reject(err);
        });
    });
  },
  register({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      auth
        .register(payload)
        .then((res) => {
          dispatch("api/handleServiceException", { e: res }, { root: true });
          resolve(res);
        })
        .catch((err) => {
          dispatch("api/handleServiceException", { e: err }, { root: true });
          reject(err);
        });
    });
  },
  restPassword({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      auth
        .restPassword(payload)
        .then((res) => {
          dispatch("api/handleServiceException", { e: res }, { root: true });
          resolve(res);
        })
        .catch((err) => {
          dispatch("api/handleServiceException", { e: err }, { root: true });
          reject(err);
        });
    });
  },
  setPassword({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      auth
        .setPassword(payload)
        .then((res) => {
          dispatch("api/handleServiceException", { e: res }, { root: true });
          resolve(res);
        })
        .catch((err) => {
          dispatch("api/handleServiceException", { e: err }, { root: true });
          reject(err);
        });
    });
  },
  updatePassword({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      auth
        .updatePassword(payload)
        .then((res) => {
          dispatch("api/handleServiceException", { e: res }, { root: true });
          resolve(res);
        })
        .catch((err) => {
          dispatch("api/handleServiceException", { e: err }, { root: true });
          reject(err);
        });
    });
  },

  logout({ commit }) {
    commit("logout");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    router.replace("/login");
  },
};
